import {
  AfterViewInit,
  Component,
  Input,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';
import { CdkContextMenuTrigger } from '@angular/cdk/menu';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DebtorInvoiceHistoricDTO } from '../../minutes/interface/minute-request-kpis.interface';

@Component({
  selector: 'app-minutes-debtors',
  templateUrl: './minutes-debtors.component.html',
  styleUrls: ['./minutes-debtors.component.scss'],
})
export class MinutesDebtorsComponent implements AfterViewInit {
  @Input() debtorsInvoiceHistoric: Array<DebtorInvoiceHistoricDTO> = [];
  @Input() recieveFilterName: string;

  @ViewChild('chart') chart: ChartComponent = Object.create(null);
  @ViewChild(CdkContextMenuTrigger)
  menu!: CdkContextMenuTrigger;

  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator =
    Object.create(null);

  public dataSource!: MatTableDataSource<DebtorInvoiceHistoricDTO>;
  public displayedColumns: string[] = [
    'debtorName',
    'debtorRut',
    'sellInvoiceTotalAmount',
    'buyInvoiceTotalAmount',
  ];
  top: boolean = false;

  constructor() {}
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setDataSource(this.debtorsInvoiceHistoric);
    //console.log(this.debtorsInvoiceHistoric)
    // if (changes['deptors']) {
    //   const newDeptors = changes['deptors'].currentValue;
    //   this.applyFilter();

    //   if (newDeptors && newDeptors.length > 0) {
    //     this.setDataSource(newDeptors);
    //   }
    // }
  }
  private setDataSource(dataSource: Array<DebtorInvoiceHistoricDTO>) {
    this.dataSource = new MatTableDataSource<DebtorInvoiceHistoricDTO>(
      dataSource
    );
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter() {
    const filterValue = this.recieveFilterName;
    if (this.dataSource && filterValue !== undefined) {
      const filter = filterValue;
      this.dataSource.filter = filter;
    }
  }

  public calculateBuyTotalAmount(): number {
    const buyTotal: number = this.debtorsInvoiceHistoric.reduce((acc, item) => {
      return acc + item.buyInvoiceTotalAmount;
    }, 0);
    return buyTotal;
  }

  public calculateSellTotalAmount(): number {
    const sellTotal: number = this.debtorsInvoiceHistoric.reduce(
      (acc, item) => {
        return acc + item.sellInvoiceTotalAmount;
      },
      0
    );
    return sellTotal;
  }
}
